import React, {useState} from 'react';
import PersonalInfo from '../../Share/PersonalInfo/PersonalInfo';
import Result from '../../UserDashboard/ServeyQuestions/Result';
import './UserDetail.css';

const UserDetail = ({ user, editable, onBack }) => {
     if (!user) {
        return <div>Loading user details...</div>;
    }
    
    return (
        <div className="user-detail-split-wrapper">
            <div className="user-detail-split-container">
                <div className="user-detail-split-header">
                    <div className="header-content">
                        <h2 className="user-name-title">
                            <span className="user-avatar-small">
                                {user.firstname?.[0]}{user.lastname?.[0]}
                            </span>
                            {user.firstname} {user.lastname}
                        </h2>
                        {/* <p className="user-subtitle">User Profile & Survey Results</p> */}
                    </div>
                    <button 
                        onClick={onBack || (() => window.history.back())} 
                        className="header-back-button"
                    >
                        ← Back to List
                    </button>
                </div>

                <div className="user-detail-split-body">
                    <div className="split-panel left-panel">
                        <div className="panel-header">
                            <span className="panel-icon">👤</span>
                            <h3>Personal Information</h3>
                        </div>
                        <div className="panel-content">
                            <PersonalInfo user={user} editable={false} />
                        </div>
                    </div>

                    <div className="split-panel right-panel">
                        <div className="panel-header">
                            <h3>Survey Results</h3>
                        </div>
                        <div className="panel-content">
                            <Result userId={user._id} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserDetail;